import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Subject, ReplaySubject, BehaviorSubject } from 'rxjs';
import { FormGroup, ValidationErrors } from '@angular/forms';
import { CommonErrorName, CustomErrorName, FormControlGroupName, FormControlName } from '../enums/error-message.const';
import { Account } from '../models/account.model';
import { AccountStatement } from '../models/account/account-statement.model';
import { AccountBasicData } from '../models/account/account-basic-data.model';
import { FormControlError } from '../core/models/form-control-error.model';
import { Basic } from 'src/app/core/models/basic.model';
import { Despacho } from '../models/virtual-store/despacho.model';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  private unauthorizedAnnouncedSource = new Subject();
  unauthorizedAnnounced = this.unauthorizedAnnouncedSource.asObservable();

  announceUnauthorized() {
    this.unauthorizedAnnouncedSource.next();
  }

  private accountSelectedAnnouncedSource = new ReplaySubject<Account>(1);
  accountSelectedAnnounced = this.accountSelectedAnnouncedSource.asObservable();

  announceAccountSelected(account: Account) {
    this.accountSelectedAnnouncedSource.next(account);
  }
  clearAccountSelectedAnnouncedSource() {
    this.accountSelectedAnnouncedSource = new ReplaySubject<Account>(1);
    this.accountSelectedAnnounced = this.accountSelectedAnnouncedSource.asObservable();
  }

  private accountListLoadedAnnouncedSource = new ReplaySubject<Account[]>(1);
  accountListLoadedAnnounced = this.accountListLoadedAnnouncedSource.asObservable();

  announceAccountListLoaded(accountList: Account[]) {
    this.accountListLoadedAnnouncedSource.next(accountList);
  }

  private accountStatementFetchedAnnouncedSource = new Subject<AccountStatement>();
  accountStatementFetchedAnnounced = this.accountStatementFetchedAnnouncedSource.asObservable();

  announceAccountStatementFetched(accountStatement: AccountStatement) {
    this.accountStatementFetchedAnnouncedSource.next(accountStatement);
  }

  private accountDataFetchedAnnouncedSource = new Subject<AccountBasicData>();
  accountDataFetchedAnnounced = this.accountDataFetchedAnnouncedSource.asObservable();

  announceAccountDataFetched(accountBasicData: AccountBasicData) {
    this.accountDataFetchedAnnouncedSource.next(accountBasicData);
  }

  private popupClosedAnnouncedSource = new Subject<boolean>();
  popupClosedAnnounced = this.popupClosedAnnouncedSource.asObservable();

  announcePopupClosed(close: boolean) {
    this.popupClosedAnnouncedSource.next(close);
  }

  private filterActivatedAnnouncedSource = new BehaviorSubject<boolean>(true);
  filterActivatedAnnounced = this.filterActivatedAnnouncedSource.asObservable();

  announceFilterActivated(status: boolean) {
    this.filterActivatedAnnouncedSource.next(status);
  } 

  private categoryAndFilterSelectedAnnouncedSource = new ReplaySubject<Basic<string>[]>(1);
  categoryAndFilterSelectedAnnounced = this.categoryAndFilterSelectedAnnouncedSource.asObservable();

  announceCategoryAndFilterSelected(filterList: Basic<string>[]) {
    this.categoryAndFilterSelectedAnnouncedSource.next(filterList);
  }

  private ActivateDelyveriSource = new BehaviorSubject<Despacho>(new Despacho);
  ActivateDelyveri = this.ActivateDelyveriSource.asObservable();

  deliveryActivated(despacho: Despacho) {
    this.ActivateDelyveriSource.next(despacho);
  }  

  constructor(private httpClient: HttpClient) { }

  /**
   * Obtiene los errores del formulario
   * @param formGroup 
   */
  getFormErrorList(formGroup: FormGroup, formGroupKey?: string): FormControlError[] {
    let errorList: FormControlError[] = [];
    Object.keys(formGroup.controls).forEach(controlKey => {
      const controlErrors: ValidationErrors = formGroup.get(controlKey).errors;
      if (controlErrors != null) {
        Object.keys(controlErrors).forEach(errorKey => {
          errorList.push({ control: controlKey, error: errorKey, parent: formGroupKey })
        });
      }
      if (formGroup.get(controlKey)['controls'] !== undefined) {
        this.getFormErrorList(formGroup.get(controlKey) as FormGroup, controlKey).forEach(item => {
     
          errorList.push(item);
        })
      }
    });

    //Solo para el formulario principal
    if (formGroupKey === undefined && formGroup.errors != null) {
      Object.keys(formGroup.errors).forEach(errorKey => {
        errorList.push({
          control: formGroupKey, error: errorKey, parent: formGroupKey
        })
      });
    }
    return errorList;
  }

  getErrorHtmlList(errors: string[]) {
    let htmlError = '';
    errors.forEach(error => {
      htmlError = htmlError + "<li>" + error + "</li>";
    });
    return "<ul style='text-align: left;'>" + htmlError + "</ul>";
  }

  getErrorHtmlListForLogin(errors: string[]) {
    let htmlError = '';
    errors.forEach(error => {
      htmlError = htmlError + "<li>" + error + "</li>";
    });
    return "<ul class='p-0 redError'>" + htmlError + "</ul>";
  }

  getFormattedFormErrorString(formControlErrorList: FormControlError[]) {
    let errorString = "";
    if (formControlErrorList != null) {
      formControlErrorList.forEach(item => {

        if (CustomErrorName[item.error] !== undefined) {
          errorString = errorString.concat(`<li>
          ${CustomErrorName[item.error]}</li>`);
        } else if (CommonErrorName[item.error] !== undefined) {
          console.log(item)
          console.log(`<li>
          ${FormControlName[item.control]}
          
          ${CommonErrorName[item.error]}</li>`)
          errorString = errorString.concat(`<li>
          ${FormControlName[item.control]}
          ${FormControlGroupName[item.parent] !== undefined ? FormControlGroupName[item.parent] : ''}
          ${CommonErrorName[item.error]}</li>`);
        } else {
          errorString = errorString.concat('Error no identificado.');
        }
      })
    }
    return errorString;
  }

  buildFormErrorString(mainformGroup: FormGroup) {
    let formErrorList = this.getFormErrorList(mainformGroup);
    return this.getFormattedFormErrorString(formErrorList);
  }
  /**
   * Crea una plantilla html en string con los errores encontrados en el formGroup
   * @param formGroup 
   */
  async buildErrorHtml(formGroup: FormGroup) {
    let htmlString = "";
    htmlString = await this.httpClient.get('assets/html-templates/error-alert-template.html', { responseType: 'text' }).toPromise();
    let stringList = this.buildFormErrorString(formGroup);
    htmlString = htmlString.replace('[errorList]', stringList);
    return htmlString;
  }
}
